import { useCallback } from 'react'
import { useScrollToNewContentSelector } from '../ScrollToNewContentStore'

/**
 * Manage the temporary content during editing operations
 * @returns {Object} - Contains methods to check if there's temporary content being added and to start editing
 * */
export const useNewContentEditing = () => {
    const {
        isAddingContent,
        removeTemporaryContent,
    } = useScrollToNewContentSelector((state) => ({
        isAddingContent: state.isAddingContent,
        removeTemporaryContent: state.removeTemporaryContent,
    }))

    // checks if a specific content item is currently being added
    const isAddingNewContent = useCallback(
        (contentId: string) => isAddingContent(contentId),
        [isAddingContent]
    )

    // removing the temporary content on lookup of ids to scroll-into-content
    const startEditing = useCallback(
        (contentId: string) => {
            if (!contentId) return

            removeTemporaryContent(contentId)
        },
        [removeTemporaryContent]
    )

    return {
        isAddingNewContent,
        startEditing,
    }
}
